<template>
  <RevDrawer :name :title="i18n(translations.modalName)">
    <template #body>
      <div class="space-y-24">
        <Benefits />
        <HowItWorks />
        <Faq />
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import translations from './ServiceDrawer.translations'
import Benefits from './components/Benefits/Benefits.vue'
import Faq from './components/Faq/Faq.vue'
import HowItWorks from './components/HowItWorks/HowItWorks.vue'

defineProps<{ name: string }>()

const i18n = useI18n()
</script>
